
import { Button } from "@/components/ui/button";
import { Mail, MessageCircle } from "lucide-react";

interface MessageFormatToggleProps {
  messageFormat: "email" | "chat";
  onFormatChange: (format: "email" | "chat") => void;
}

const MessageFormatToggle = ({ messageFormat, onFormatChange }: MessageFormatToggleProps) => {
  return (
    <div className="flex gap-2 w-full">
      <Button
        variant={messageFormat === "email" ? "default" : "outline"}
        onClick={() => onFormatChange("email")}
        className="flex-1 rounded-full"
      >
        <Mail className="h-4 w-4 mr-2" />
        Generate Email
      </Button>
      <Button
        variant={messageFormat === "chat" ? "default" : "outline"}
        onClick={() => onFormatChange("chat")}
        className="flex-1 rounded-full"
      >
        <MessageCircle className="h-4 w-4 mr-2" />
        Generate Chat
      </Button>
    </div>
  );
};

export default MessageFormatToggle;
